import { DEFAULT_ROUTES_BY_ROLE } from '@auth/consts/default-routes-by-role.const';
import { Role } from '@auth/enums/role.enum';
import { Url } from '@core/enums/url.enum';
import { AppRoutes } from '@core/interfaces/app-routes.interface';
import { lastUrlSegment } from '@core/utils/last-url-segment.util';

export const ADMIN_ROUTES: AppRoutes = [
  {
    path: lastUrlSegment(Url.AdminManageEmployees),
    children: [
      {
        path: lastUrlSegment(Url.AdminEmployeeProfiles),
        loadComponent: () =>
          import(
            '@features/manage-employees/pages/admin-employee-profiles-page/admin-employee-profiles-page.component'
          ).then((m) => m.AdminEmployeeProfilesPageComponent),
      },
      {
        path: '**',
        redirectTo: Url.AdminEmployeeProfiles,
      },
    ],
  },
  {
    path: lastUrlSegment(Url.AdminEmployeeSettings),
    children: [
      {
        path: lastUrlSegment(Url.AdminApprenticeTrainingProgramSetup),
        loadComponent: () =>
          import(
            '@features/employee-settings/pages/admin-apprentice-training-program-setup-page/admin-apprentice-training-program-setup-page.component'
          ).then((m) => m.AdminApprenticeTrainingProgramSetupPageComponent),
      },
      {
        path: lastUrlSegment(Url.AdminOtherDeductionsSetup),
        loadComponent: () =>
          import(
            '@features/employee-settings/pages/admin-other-deductions-setup-page/admin-other-deductions-setup-page.component'
          ).then((m) => m.AdminOtherDeductionsSetupPageComponent),
      },
      {
        path: lastUrlSegment(Url.AdminDemographicSetup),
        loadComponent: () =>
          import(
            '@features/employee-settings/pages/admin-demographic-setup-page/admin-demographic-setup-page.component'
          ).then((m) => m.AdminDemographicSetupPageComponent),
      },
      {
        path: '**',
        redirectTo: Url.AdminApprenticeTrainingProgramSetup,
      },
    ],
  },
  {
    path: '**',
    redirectTo: DEFAULT_ROUTES_BY_ROLE[Role.Admin],
  },
];
